import React, { useState } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';

const FormInput = ({
  label,
  error,
  value,
  onChangeText,
  leftIcon,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <View style={styles.container}>
      {label && <Text style={[styles.label, isFocused && styles.labelFocused]}>{label}</Text>}
      <View style={[
        styles.inputWrapper,
        isFocused && styles.inputWrapperFocused,
        error && styles.inputWrapperError
      ]}>
        {leftIcon && <View style={styles.iconWrapper}>{leftIcon}</View>}
        <TextInput
          style={[
            styles.input,
            leftIcon && styles.inputWithIcon,
            props.multiline && styles.multilineInput
          ]}
          value={value}
          onChangeText={onChangeText}
          placeholderTextColor="#A0AEC0"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...props}
        />
      </View>
      {error && <Text style={styles.errorText}>{error}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
    width: '100%',
  },
  label: {
    fontSize: 12,
    marginBottom: 4,
    color: '#718096',
    fontWeight: '600',
    marginLeft: 2,
  },
  labelFocused: {
    color: '#6366F1',
  },
  inputWrapper: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1.5,
    borderColor: '#EDF2F7',
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconWrapper: {
    paddingLeft: 12,
    paddingRight: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  inputWithIcon: {
    paddingLeft: 6,
  },
  inputWrapperFocused: {
    borderColor: '#6366F1',
    backgroundColor: '#FFF',
    shadowColor: '#6366F1',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 2,
  },
  inputWrapperError: {
    borderColor: '#F56565',
  },
  input: {
    flex: 1,
    paddingHorizontal: 14,
    paddingVertical: 10,
    fontSize: 14,
    color: '#2D3748',
  },
  multilineInput: {
    height: 80,
    textAlignVertical: 'top',
    paddingTop: 10,
  },
  errorText: {
    color: '#F56565',
    fontSize: 10,
    marginTop: 2,
    marginLeft: 4,
    fontWeight: '500',
  },
});

export default FormInput;
